export const getNodeByPath = function (pagePath) {
  const queryIndex = pagePath.indexOf("?");
  const pathWithoutQuery = queryIndex > -1 ? pagePath.substring(0, queryIndex) : pagePath;
  const [, navigationNode] = pathWithoutQuery.split("/");
  return navigationNode;
};
